import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';

import { slides } from '@/components/Presentation/config';
import { PresentationSlide } from '@/components/Presentation/PresentationSlide/PresentationSlide';
import { SlideShow } from '@/components/SlideShow/SlideShow';
import { useAppSelector } from '@/redux/store';

const Presentation: FC = () => {
  const isOpen = useAppSelector((state) => state.modals.presentationIsOpen);
  const { i18n } = useTranslation();

  const list =
    i18n.language in slides
      ? slides[i18n.language as keyof typeof slides]
      : slides.en;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="absolute inset-0 z-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <SlideShow
            className={
              'pt-[calc(var(--tg-safe-area-inset-top,_0px)_+_55px)] w-full h-full bg-main-bg'
            }
            list={list}
            render={(props) => <PresentationSlide {...props} />}
            preloading={{
              list: list.map(({ image }) => image.png),
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { Presentation };
